export const DOMAIN_FILES = "FILES";
